module.exports = __webpack_public_path__ + "media/images/icons/courses/7-d7d5ca6fbe280307f40a0744712b8c10.svg";